import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-exceljson-upload-popup',
  templateUrl: './exceljson-upload-popup.component.html',
  styleUrls: ['./exceljson-upload-popup.component.scss']
})
export class ExceljsonUploadPopupComponent {

  selectedType: 'excel' | 'json' | null = null;

  isUploading = false;
  progress = 0;
  private timer: any;

  constructor(public dialogRef: MatDialogRef<ExceljsonUploadPopupComponent>) {}

  selectType(type: 'excel' | 'json') {
    this.selectedType = type;
  }

  submit() {
    if (!this.selectedType) return;

    this.isUploading = true;
    this.progress = 0;

  
    this.timer = setInterval(() => {
      if (this.progress < 100) {
        this.progress += 10;
      } else {
        clearInterval(this.timer);

     
        this.dialogRef.close({
          type: this.selectedType
        });
      }
    }, 100);
  }

  closeModal() {
    if (this.timer) clearInterval(this.timer);
    this.dialogRef.close();
  }
}
